import Backbone from 'backbone';


import { NoSyncMixin } from 'zoomforth_zfutils/backbone_no_sync_model_mixin.js';
import { displayFixedErrorAlertForXhrFail } from 'zoomforth_tools/modern_helpers.js';
  
  // an ESQuery model refers to a single query --
  // its only job is sending a 'page-loaded' event when a new page is loaded
  // and having 'getNextPage' begin loading a new page
  
const ESQuery = Backbone.Model.extend({
    ...NoSyncMixin,
    
    defaultQueryParams: {
      'types': 'all',
      'page_size': 50,
      'page': 1
    }, 
    
    initialize: function(options){
      this.queryParams = { ...this.defaultQueryParams,...options.queryParams };
      this.fetching = false;
      this.finished = false;
    }, 
    
    getNextPage: function(){
      var me = this;
      
      if (this.fetching || this.finished){
        // not yet adding support for queued pages, 
        // get next page will just fail if it is already making a request
        return;
      }
      this.fetching = true;
      $.ajax({
        url: '/search/assets',
        data: me.queryParams,
        dataType: 'json',
        type: 'GET'
      }).always(function(){
        me.fetching = false;
      }).done(function(response){
        if(response.page != me.queryParams.page) {
          throw 'Mismatched pages between ES query and ES response. Weird!'
        }
        if(me.queryParams.page == response.totalPages) {
          me.finished = true;
        } else{
          me.queryParams.page += 1;
        }
        me.trigger('page-loaded', response);
        // trigger page loaded for the last page before triggering finished
        if(me.finished){
          me.trigger('finished');
        }        
      }).fail(function(response){
        displayFixedErrorAlertForXhrFail(response);
      });
    }
  });

export default ESQuery;